import React, { useRef, useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header.js";
import "./serviceDetailPage.css";

export default function ServiceDetail() {
  const { serviceId } = useParams();
  const scrollRef = useRef(null);
  
  // 1. State for the specific service we are viewing
  const [service, setService] = useState(null);
  
  // 2. State for the list of OTHER services (for the slider)
  const [otherServices, setOtherServices] = useState([]);

  useEffect(() => {
    // --- FETCH 1: Get the specific service details ---
    fetch(`https://oculus-api.onrender.com/api/services/${serviceId}`)
      .then((res) => res.json())
      .then((data) => setService(data))
      .catch((err) => console.error("Error fetching service detail:", err));

    // --- FETCH 2: Get all services for the "Other Services" slider ---
    fetch(`https://oculus-api.onrender.com/api/services`)
      .then((res) => res.json())
      .then((data) => {
        // Filter out the current service so it doesn't show up in "Other Services"
        // Note: We use string comparison just to be safe with IDs
        const others = data.filter((s) => s._id !== serviceId);
        setOtherServices(others);
      })
      .catch((err) => console.error("Error fetching other services:", err));

  }, [serviceId]); // Run this again if the user clicks a new link

  // Function to scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  // Function to scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  // Loading check (wait for data before rendering)
  if (!service) {
    return <div style={{padding: "100px", textAlign: "center"}}>Loading Service Details...</div>;
  }

  return (
    <div className="service-detail-page">
      <Header />

      <div className="service-container">
        <div className="service-text-content">
          
          {/* UPDATED: Use 'title' instead of 'name' */}
          <h1 className="service-name">{service.title}</h1>

          <div className="service-hero-image-container">
            {/* Note: Your DB schema doesn't have images yet, so we use the fallback */}
            <img 
               src={"https://augenchirurgie.org/wp-content/uploads/2018/05/augenoperation.jpg"} 
               alt={service.title}
               className="service-hero-img"
            />
          </div>

          {/* UPDATED: Description from DB */}
          <p className="service-desc">{service.description}</p>
        </div>
      </div>

      <div className="other-services-section">
        <h2 className="other-services-heading">Other Services</h2>
        
        <button className="scroll-arrow-btn left-arrow" onClick={scrollLeft}>
          &lt;
        </button>

        <button className="scroll-arrow-btn right-arrow" onClick={scrollRight}>
          &gt;
        </button>

        <div className="other-services-list" ref={scrollRef}>
          {otherServices.map((otherService) => (
            <Link
              // UPDATED: Use '_id'
              to={`/services/${otherService._id}`}
              key={otherService._id}
              className="service-card-link"
            >
              <div className="service-card">
                {/* UPDATED: Use 'title' */}
                <h3 className="service-name">{otherService.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}